export enum UserRoleEnum {
  /**Сотрудник */
  Employee = 1,
  /**Владелец */
	Owner = 2,
  /**Если админ в любом из неймспейсов */
	NamespaceAdmin = 3,
  /**Если админ в любом из проектов */
	ProjectAdmin = 4
}